export default __webpack_public_path__ + "images/JL.13c76f7.png";